import type { ApiRequest } from '@batiflow/client-core';
import { StepUpDialog } from '@batiflow/ui';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRuntime } from '@/app/providers/runtime-provider';

/**
 * 403 STEP_UP_REQUIRED: every back-office write needs a recent WebAuthn confirmation. Explains
 * why, then goes to the step-up; the refused action is remembered and replayed on return
 * (PendingActionReplay).
 */
export function StepUpController() {
  const { t } = useTranslation('backoffice');
  const { stepUpBus, startStepUp } = useRuntime();
  const [request, setRequest] = useState<ApiRequest | null>(null);

  useEffect(
    () =>
      stepUpBus.on((refused) => {
        setRequest(refused);
      }),
    [stepUpBus],
  );

  return (
    <StepUpDialog
      open={request !== null}
      onOpenChange={(open) => {
        if (!open) setRequest(null);
      }}
      reason={t('stepUp.reason')}
      onContinue={() => {
        if (request) startStepUp(request);
      }}
    />
  );
}
